import React from "react";
import { Box, Typography } from "@mui/material";

import LinkDisplay from "components/Base/LinkDisplay";

import { Organisation } from "api/Accounts/AccountsInterfaces";
import { baseURLFrontend } from "api/APIClient";

interface OrganisationCollaboratorsTabProps {
  organisation: Organisation;
}

const OrganisationCollaboratorsTab: React.FC<
  OrganisationCollaboratorsTabProps
> = ({ organisation }) => {
  return (
    <Box>
      <Typography
        variant="body1"
        sx={{
          mb: 2,
        }}
      >
        Send this link to your collaborators to allow them
        to register an account.
      </Typography>

      <Typography
        variant="body1"
        sx={{
          mb: 2,
        }}
      >
        Your team members can always access your interaction
        pages without registering an account.
      </Typography>

      <LinkDisplay
        url={`${baseURLFrontend}/register/collaborator/${organisation.public_token}/`}
        withBackground
        showCopyButton
        showText
        qrFileName="Register-collaborator-qr-code"
        showQrDownloadButton
        showOpenButton

      />
    </Box>
  );
};

export default OrganisationCollaboratorsTab;